import { VehicleDetailsContainer, vehicleDetailsReducer } from '@makemydeal/dr-activities-vehicle-details';
import { vehicleDetailsMiddleware } from './middleware';
import { VEHICLE_DETAILS_ROUTE } from './constants';

export const vehicleDetailsConfiguration = {
    middleware: vehicleDetailsMiddleware,
    reducer: vehicleDetailsReducer,
    defaultRoute: VEHICLE_DETAILS_ROUTE,
    routingComponent: VehicleDetailsContainer
};
